import React, { useState } from "react";
import { Card, CardContent, Typography, Box, IconButton, Tooltip } from "@mui/material";
import FullscreenIcon from "@mui/icons-material/Fullscreen";
import FullscreenExitIcon from "@mui/icons-material/FullscreenExit";
import Loader from "../Loader";

const IframeCard = ({ title, url, onMaximize, isMaximized }) => {
  const [isLoading, setIsLoading] = useState(true);

  return (
    <Card
      elevation={0}
      sx={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
        background: "transparent",
        overflow: "hidden",
        transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
      }}
    >
      <Box
        sx={{
          p: 0.5,
          px: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          zIndex: 2,
        }}
      >
        <Typography
          variant="body2"
          sx={{
            fontWeight: 700,
            color: "text.primary",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            fontSize: "0.8rem",
            opacity: 0.8,
          }}
        >
          {title}
        </Typography>
        <Box sx={{ display: "flex", gap: 0.5 }}>
          <Tooltip title={isMaximized ? "Restore" : "Maximize"}>
            <IconButton
              size="small"
              onClick={onMaximize}
              sx={{ p: 0.5, color: "text.secondary", "&:hover": { color: "primary.main" } }}
            >
              {isMaximized ? <FullscreenExitIcon sx={{ fontSize: 16 }} /> : <FullscreenIcon sx={{ fontSize: 16 }} />}
            </IconButton>
          </Tooltip>
        </Box>
      </Box>
      <CardContent
        sx={{
          flexGrow: 1,
          p: 0,
          position: "relative",
          "&:last-child": { pb: 0 },
          minHeight: 0,
          overflow: "hidden"
        }}
      >
        {isLoading && (
          <Box sx={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 10, backgroundColor: 'background.paper' }}>
            <Loader variant="dots" message="" />
          </Box>
        )}
        <Box
          component="iframe"
          src={url}
          onLoad={() => setIsLoading(false)}
          title={title}
          sx={{
            width: "100%",
            height: "100%",
            border: "none",
            display: "block",
            backgroundColor: "background.paper",
          }}
        />
      </CardContent>
    </Card>
  );
};

export default IframeCard;
